import Component from '@glimmer/component';
import { tracked } from 'tracked-built-ins';
import type FamilyModel from 'frontend/models/family';
import { action } from '@ember/object';

interface SearchPageFiltersFamiliesListElementListComponentArgs {
  family: FamilyModel;
  current: string[];
  updateFamilies: (id: string) => {};
}

export default class SearchPageFiltersFamiliesListElementListComponent extends Component<SearchPageFiltersFamiliesListElementListComponentArgs> {
  @tracked isOpen = false;
  constructor(
    owner: unknown,
    args: SearchPageFiltersFamiliesListElementListComponentArgs
  ) {
    super(owner, args);

    if (this.hasSubFamiliesInCurrent()) {
      this.isOpen = true;
    }
  }

  @action
  updateFamilies(id: string) {
    this.isOpen = true;
    this.args.updateFamilies(id);
  }

  @action
  toggleChildren() {
    this.isOpen = !this.isOpen;
  }

  private hasSubFamiliesInCurrent() {
    return this.args.family.children
      .toArray()
      .some((element) => this.args.current.includes(element.id));
  }
}
